import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFormControl } from '../components/base-form-control/Component.js';

var defaultColors = {"inner":"form-control__inner_rwmho","focused":"form-control__focused_rwmho","hasError":"form-control__hasError_rwmho","disabled":"form-control__disabled_rwmho"};
require('./default.desktop.css')

var styles = {"above":"form-control__above_zlfvp","sub":"form-control__sub_zlfvp","error":"form-control__error_zlfvp","size-40":"form-control__size-40_zlfvp","inner":"form-control__inner_zlfvp","size-48":"form-control__size-48_zlfvp","size-56":"form-control__size-56_zlfvp","size-64":"form-control__size-64_zlfvp","size-72":"form-control__size-72_zlfvp"};
require('./desktop.css')

var invertedColors = {"inner":"form-control__inner_st2bt","hasError":"form-control__hasError_st2bt","disabled":"form-control__disabled_st2bt"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var FormControlDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseFormControl, __assign({}, restProps, { ref: ref, styles: styles, colorStyles: colorStyles }))); });

export { FormControlDesktop };
